export const convertNumberToPercentage = (value?: number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // Guard undefined like formatNumberToCurrency: a grid valueFormatter can pass
  // undefined for empty/aggregate cells, which would otherwise render "NaN%".
  return formatter.format(value ?? 0);
};

export const formatOptionalNumber = (
  value: number | null | undefined,
  fallback = '—',
  locales?: Intl.LocalesArgument,
  options?: Intl.NumberFormatOptions,
) =>
  typeof value === 'number' && Number.isFinite(value)
    ? value.toLocaleString(locales, options)
    : fallback;

/** Formats a percentage to exactly two decimal places and returns the result as a string.
 * It rounds the number up or down to the nearest digit based on the third decimal place. */
export const formatPercentValue = (
  percentage: number | null | undefined,
): string => {
  if (!percentage) return '0%';
  return `${percentage.toFixed(2)}%`;
};
